export const isOutOfStockError = (errorMessage: string) => {
  return (
    errorMessage === 'CART_CHECKOUT_ITEM_OUT_OF_STOCK' ||
    errorMessage === 'CART_ITEM_OUT_OF_STOCK' ||
    errorMessage === 'OUT_OF_STOCK'
  );
};
